const DeliveryDaySlotsTypes = {
  DELIVERY_DAY_SLOTS_LOADING: "DELIVERY_DAY_SLOTS_LOADING",
  GET_DELIVERY_DAY_SLOTS_SUCCESS: "GET_DELIVERY_DAY_SLOTS_SUCCESS",
  UPDATE_DELIVERY_DAY_SLOT_SUCCESS: "UPDATE_DELIVERY_DAY_SLOT_SUCCESS",
  GET_DELIVERY_SLOT_DAYS_SUCCESS: "GET_DELIVERY_SLOT_DAYS_SUCCESS",
  UPDATE_DELIVERY_SLOT_DAYS_SUCCESS: "UPDATE_DELIVERY_SLOT_DAYS_SUCCESS",
};
export default DeliveryDaySlotsTypes;
